import { createSelector } from 'reselect';
import { AppState } from '../reducers';

const integrationsResourceSelector = (state: AppState) => state.clio;

export const clioSelfSelector = createSelector(integrationsResourceSelector, (clio) => clio.login.self);
